import { useQuery } from '@tanstack/react-query';
import fetchAPI from '../fetchAPI';

interface callGetSrtTokenProps {
  from?: string | null;
  to?: string | null;
  billingAccountId?: string;
  locationId?: string;
  pageNumber?: number;
  pageSize?: number;
  markupType?: string;
}

export const useSrtTokens = <T>({
  from,
  to,
  billingAccountId,
  pageNumber,
  pageSize,
  locationId,
  markupType
}: callGetSrtTokenProps) => {
  const queryParams = new URLSearchParams();
  if (from) queryParams.append('from', from);
  if (to) queryParams.append('to', to);
  if (billingAccountId) queryParams.append('billingAccountId', billingAccountId);
  if (locationId) queryParams.append('locationId', locationId);
  if (pageNumber) queryParams.append('pageNumber', pageNumber.toString());
  if (pageSize) queryParams.append('pageSize', pageSize.toString());
  if (markupType) queryParams.append('markupType', markupType);

  const queryString = queryParams.toString();

  return useQuery({
    queryKey: ['srt', from, to, billingAccountId, locationId, markupType, pageNumber, pageSize],
    queryFn: async () => {
      const response = await fetchAPI<T>({
        method: `GET`,
        route: `srt`,
        queryString
      });
      return response;
    },
    enabled: !!from && !!to,
    // Analytics — see useAISrtTokens for rationale.
    staleTime: 10 * 60 * 1000
  });
};

export default useSrtTokens;
